// extracted by mini-css-extract-plugin
export default {"cuerpo":"Ordenes_cuerpo__68Izw","header":"Ordenes_header__DhtmO","filtro":"Ordenes_filtro__XDzd7","tabla":"Ordenes_tabla__nOWs7","rows":"Ordenes_rows__BjbhD"};